(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.newsletterAjaxForm = {
    attach: function (context, settings) {
      $(once("form", ".newsletter", context))
        .each(function (i, form) {
          bindFormEvents($(form).find(".form"));
        });

      function bindFormEvents(form) {
        const $newsletterBtn = form.find(".js-submit-newsletter-btn");

        $newsletterBtn.on("click", function (e) {
          const $newsletterForm = $(this).closest("form");
          const $styledBtn = $(this).closest(".form__cta");
          const $formText = form.parent().find(".form-text");
          const $hiddenSuccess = form.parent().find(".success-message");
          const $hiddenError = form.parent().find(".error-message");
          const $newsletterRequired = $newsletterForm.find(".required-field");
          const $requiredCheckboxes =
            $newsletterForm.find(".required-checkbox");
          let $valid = [];
          let valueArray = [];

          const contactTrackId = form.find(".js-newsletter-gatrackid", context);
          const contactClientId = form.find(".js-newsletter-ga_client_id", context);
          const contactUserGa = form.find(".js-newsletter-gausercat", context);

          if (typeof ga !== 'undefined') {
            ga(() => {
              const gaCont = ga.getAll()[0];
              const clientId = gaCont.get("clientId") || "undefined";
              const trackId = gaCont.get("trackingId") || "undefined";
              const userId = gaCont.get("userGa") || "undefined";

              if (contactTrackId.length) {
                contactTrackId.each(function (index, input) {
                  input.value = trackId;
                });
              }

              if (contactClientId.length) {
                contactClientId.each(function (index, input) {
                  input.value = clientId;
                });
              }

              if (contactUserGa.length) {
                contactUserGa.each(function (index, input) {
                  input.value = userId;
                });
              }
            });
          }

          const utmSourceNl = form.find(".js-newsletter-utm-source", context);
          const utmMediumNl = form.find(".js-newsletter-utm-medium", context);
          const utmCampaignNl = form.find(".js-newsletter-utm-campaign", context);
          const utmContentNl = form.find(".js-newsletter-utm-content", context);
          const utmTermNl = form.find(".js-newsletter-utm-term", context);

          const sourceVal = window.parent.sessionStorage.getItem('utm_source') || "undefined";
          const mediumVal = window.parent.sessionStorage.getItem('utm_medium') || "undefined";
          const campaignVal = window.parent.sessionStorage.getItem('utm_campaign') || "undefined";
          const contentVal = window.parent.sessionStorage.getItem('utm_content') || "undefined";
          const termVal = window.parent.sessionStorage.getItem('utm_term') || "undefined";

          if (utmSourceNl.length) {
            utmSourceNl.each(function (index, input) {
              input.value = sourceVal;
            });
          }
          if (utmMediumNl.length) {
            utmMediumNl.each(function (index, input) {
              input.value = mediumVal;
            });
          }
          if (utmCampaignNl.length) {
            utmCampaignNl.each(function (index, input) {
              input.value = campaignVal;
            });
          }
          if (utmContentNl.length) {
            utmContentNl.each(function (index, input) {
              input.value = contentVal;
            });
          }
          if (utmTermNl.length) {
            utmTermNl.each(function (index, input) {
              input.value = termVal;
            });
          }

          const pageTitleData = $("body", context).data("pagetitle");
          const pageIdData = $("body", context).data("pageid");

          const pageTitleValue = $(".page-title", context);
          const pageIdValue = $(".page-id", context);

          if (pageTitleValue.length) {
            pageTitleValue.each(function (index, input) {
              input.value = pageTitleData;
            });
          }

          if (pageIdValue.length) {
            pageIdValue.each(function (index, input) {
              input.value = pageIdData;
            });
          }

          function pushData(data) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ...data });
          }

          function pushNewsletterData() {
            pushData({
              event: "ga-event",
              eventCategory: "Std Newsletter Subs",
              eventAction: `Click`,
              eventLabel: `Standalone`,
              eventValue: undefined,
              nonInteraction: false,
            });
          }

          $requiredCheckboxes.each((index, checkbox) => {
            const $parent = $(checkbox).closest(".js-form-row");
            const $errorField = $parent.find(".js-field-error");
            if (!checkbox.checked) {
              if ($errorField) {
                $errorField.text($errorField.data("empty"));
                $valid.push(false);
              }
              checkbox.classList.add("is-empty");
            } else {
              checkbox.classList.remove("is-empty");
              $errorField.text("");
            }
          });

          function hasDuplicates(array) {
            let arrayCompare = Object.create(null);
            for (let i = 0; i < array.length; ++i) {
              let value = array[i];
              if (value in arrayCompare) {
                return array[i];
              }
              arrayCompare[value] = true;
            }
            return false;
          }

          $newsletterRequired.each(function (i, input) {
            const $parent = $(input).closest(".js-form-row");
            const $errorField = $parent.find(".js-field-error");
            valueArray.push(input.value);
            if (input.value === "") {
              input.classList.add("is-empty");
              input.classList.remove("not-empty");
              if ($errorField) {
                $errorField.text($errorField.data("empty"));
                $valid.push(false);
              }
            } else {
              input.classList.add("not-empty");
              input.classList.remove("is-empty");

              if ($errorField) {
                $errorField.text("");
              }

              hasDuplicates(valueArray);
              if (input.value === hasDuplicates(valueArray)) {
                input.classList.add('is-empty');
                input.nextElementSibling.nextElementSibling.innerHTML = $errorField.data("invalidEqual");
                $valid.push(false);
              }
              // Named homepage url but it's for avoiding bots.
              const homepageURL = document.querySelector('.js-homepage-url');
              if (homepageURL.value) {
                $valid.push(false);
              }
              if (input.getAttribute("type") === "email") {
                if (!validateEmail(input)) {
                  input.classList.remove("not-empty");
                  input.classList.add("is-empty");
                  if ($errorField) {
                    $errorField.text($errorField.data("invalid"));
                    $valid.push(false);
                  }
                }
                const flag = $parent.data('emailBlocking');
                if (flag === 1) {
                  const emailDomainsArray = $parent.data('emailDomains').length ? $parent.data('emailDomains').split('|') : '';
                  const emailDomainError = $errorField.data('blocked').length ? $errorField.data('blocked') : '';
                  const mailProvider = input.value.split('@').pop().split('.')[0];
                  if (emailDomainsArray.includes(mailProvider)) {
                    input.classList.add("is-empty");
                    input.classList.remove("not-empty");
                    $errorField.text(emailDomainError);
                    $valid.push(false); // Prevent form submission if flag is 1
                  }
                }
              }
            }
          });

          function validateEmail(field) {
            const re = /[a-zA-Z0-9+-_%.]+@[a-zA-Z0-9_-]+\.[A-Za-z0-9]{2,64}/;
            return re.test(field.value);
          }

          if ($valid.includes(false)) {
            e.preventDefault();
            $valid = [];
          } else {
            e.preventDefault();
            const _continue = function(e, form) {
              console.log('in continue');
              $.ajax({
                url: "/submit-newsletter-forms",
                type: "POST",
                data: $newsletterForm.serialize(),
                dataType: "json",
                beforeSend: function () {
                  form.find('#loader').removeClass("hidden");
                  $newsletterBtn.prop("disabled", true);
                },
                success: function (response) {
                  if (
                    typeof response.page_status !== "undefined" &&
                    response.page_status === "success"
                  ) {
                    const newsletterPopup = document.querySelector('.js-newsletter-popup');
                    if (newsletterPopup && newsletterPopup.dataset.popup) {
                      const html = document.querySelector('html');
                      var expDate = new Date();
                      expDate.setTime(expDate.getTime() + (60 * 24 * 60 * 60 * 1000));
                      document.cookie = 'hide_newsletter_popup_' + html.lang + '=1; expires=' + expDate.toGMTString() + '; path=/';
                    }
                    $newsletterBtn.prop("disabled", true);
                    form.find('#loader').addClass("hidden");
                    $styledBtn.addClass("form__cta--success");
                    $formText.css("display", "none");
                    $hiddenSuccess.css("display", "block");
                    pushNewsletterData();

                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                  } else {
                    e.preventDefault();
                    $styledBtn.addClass("form__cta--fail");
                    $newsletterBtn.prop("disabled", true);
                    if ($hiddenError.text().length > 0) {
                      $formText.css("display", "none");
                      $hiddenError.css("display", "block");
                    } else {
                      $formText.css("display", "block");
                    }
                  }
                },
                error: function () {
                  console.log('some error');
                  $newsletterForm[0].reset();
                },
              });
            }

            if (document.getElementById('h-captcha-sitekey-popup').value) {
              const key = document.getElementById('h-captcha-sitekey-popup').value;
              console.log('Setting up hCaptcha for form index: newsletter');
              const g = document.createElement('div');
              g.className = 'captcha_widget-id';
              form.append(g);
              const hcaptchaSetHCFieldWebform = function(response, form) {
                console.log('hCaptcha token received: newsletter', response);
                window.havePasscode = true;
                window.curPasscode = response;
                const response_placeholder = form[0].getElementsByClassName('js-hcaptcha-token');
                if (response_placeholder) response_placeholder[0].value = response;
                console.log('hCaptcha token set in form: newsletter');
                _continue(e, form);
              };
              console.log('hCaptcha container added to the form. newsletter');
              const _widgetID = hcaptcha.render(g, {
                size: 'invisible',
                sitekey: key,
                callback: function(response) {
                  console.log('callback');
                  hcaptchaSetHCFieldWebform(response, form);
                }.bind(form)
              });
              console.log('widget2:', _widgetID);
              console.log('Form submit intercepted for form index: newsletter');
              hcaptcha.execute(_widgetID); // Execute the hCaptcha
              console.log('hCaptcha execute called for widget ID:', _widgetID);
            } else {
              _continue(e, form);
            }

            return false;
          }
        });
      }
    },
  };
})(jQuery, Drupal, once);
